var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 112,
    viewBox: "0 0 171 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_413_557)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.75,
    y: 77.5078,
    width: 10,
    height: 1.5,
    transform: "rotate(-2.93058 14.75 77.5078)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.8613,
    y: 76.7168,
    width: 10,
    height: 1.5,
    transform: "rotate(-7.6706 28.8613 76.7168)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.959,
    y: 74.6152,
    width: 10,
    height: 1.5,
    transform: "rotate(-8.75481 42.959 74.6152)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1602,
    y: 72.4199,
    width: 10,
    height: 1.5,
    transform: "rotate(-10.7961 57.1602 72.4199)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.0996,
    y: 69.6289,
    width: 10,
    height: 1.5,
    transform: "rotate(-15.6828 71.0996 69.6289)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8633,
    y: 65.5859,
    width: 10,
    height: 1.5,
    transform: "rotate(-18.8172 84.8633 65.5859)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.2578,
    y: 60.8574,
    width: 10,
    height: 1.5,
    transform: "rotate(-26.1946 98.2578 60.8574)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.631,
    y: 54.3945,
    width: 10,
    height: 1.5,
    transform: "rotate(-33.2003 110.631 54.3945)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.723,
    y: 46.3281,
    width: 10,
    height: 1.5,
    transform: "rotate(-36.8477 122.723 46.3281)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.008,
    y: 37.6836,
    width: 10,
    height: 1.5,
    transform: "rotate(-45.1221 134.008 37.6836)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.145,
    y: 27.7051,
    width: 10,
    height: 1.5,
    transform: "rotate(-54.5558 144.145 27.7051)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.625,
    y: 14.4434,
    width: 10,
    height: 1.5,
    transform: "rotate(-168.622 150.625 14.4434)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.529,
    y: 15.6602,
    width: 10,
    height: 1.5,
    transform: "rotate(136.961 137.529 15.6602)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.73,
    y: 25.7383,
    width: 10,
    height: 1.5,
    transform: "rotate(116.053 127.73 25.7383)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.805,
    y: 38.6699,
    width: 10,
    height: 1.5,
    transform: "rotate(84.2978 122.805 38.6699)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.012,
    y: 52.4551,
    width: 10,
    height: 1.5,
    transform: "rotate(67.3316 125.012 52.4551)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.842,
    y: 65.3438,
    width: 10,
    height: 1.5,
    transform: "rotate(58.2835 130.842 65.3438)",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.711,
    y: 78.9023,
    width: 10,
    height: 1.5,
    transform: "rotate(52.3093 139.711 78.9023)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-1_413_557",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.004 95.6756C153.37 97.1537 152.25 98.3713 150.83 99.1272C149.41 99.8831 147.775 100.132 146.194 99.8334C144.613 99.5346 143.182 98.7058 142.136 97.4837C141.089 96.2616 140.491 94.7194 140.44 93.1115C140.388 91.5037 140.887 89.9263 141.853 88.6399C142.819 87.3535 144.194 86.4349 145.753 86.0357C147.311 85.6365 148.959 85.7806 150.424 86.4442C151.89 87.1079 153.085 88.2513 153.813 89.6859L151.016 91.1052C150.611 90.307 149.946 89.6708 149.13 89.3015C148.315 88.9323 147.398 88.8521 146.531 89.0742C145.664 89.2963 144.898 89.8074 144.361 90.5232C143.824 91.239 143.546 92.1166 143.575 93.0113C143.604 93.9059 143.936 94.764 144.518 95.444C145.1 96.1239 145.897 96.5851 146.776 96.7514C147.656 96.9176 148.566 96.779 149.356 96.3584C150.146 95.9378 150.769 95.2604 151.122 94.4379L154.004 95.6756Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.004 95.6756C153.37 97.1537 152.25 98.3713 150.83 99.1272C149.41 99.8831 147.775 100.132 146.194 99.8334C144.613 99.5346 143.182 98.7058 142.136 97.4837C141.089 96.2616 140.491 94.7194 140.44 93.1115C140.388 91.5037 140.887 89.9263 141.853 88.6399C142.819 87.3535 144.194 86.4349 145.753 86.0357C147.311 85.6365 148.959 85.7806 150.424 86.4442C151.89 87.1079 153.085 88.2513 153.813 89.6859L151.016 91.1052C150.611 90.307 149.946 89.6708 149.13 89.3015C148.315 88.9323 147.398 88.8521 146.531 89.0742C145.664 89.2963 144.898 89.8074 144.361 90.5232C143.824 91.239 143.546 92.1166 143.575 93.0113C143.604 93.9059 143.936 94.764 144.518 95.444C145.1 96.1239 145.897 96.5851 146.776 96.7514C147.656 96.9176 148.566 96.779 149.356 96.3584C150.146 95.9378 150.769 95.2604 151.122 94.4379L154.004 95.6756Z",
    stroke: "white",
    strokeWidth: 4.16975,
    mask: "url(#path-19-inside-1_413_557)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_413_557",
    x: 4.75,
    y: 1,
    width: 159.254,
    height: 108.957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_413_557"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_413_557",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps2);
export default __webpack_public_path__ + "static/media/steps_2.fd526f323764d4855a2fe8b22565bf04.svg";
export { ForwardRef as ReactComponent };